<app-admin-header></app-admin-header>

<div class="store-report-container">
  <app-admin-sidebar></app-admin-sidebar>

  <h2>🏪 Store Drug Report</h2>

  <label for="store">Select Store:</label>
  <select id="store" [(ngModel)]="selectedStoreId" (change)="loadReport()">
    <option [ngValue]="null">-- Select a Store --</option>
    <option *ngFor="let store of stores" [value]="store.id">{{ store.name }}</option>
  </select>

  <!-- 🔍 Filter section -->
  <div class="filter-container" *ngIf="reportData.length">
    <label for="filter">Filter Drugs by Name:</label>
    <div class="filter-row">
      <input
        id="filter"
        type="text"
        [(ngModel)]="drugFilter"
        (input)="applyDrugFilter()"
        placeholder="Search by drug name..."
      />
      <button type="button" class="reset-btn" (click)="resetDrugFilter()">Reset</button>
    </div>
  </div>

  <!-- 🔄 Loading -->
  <div *ngIf="loading">🔄 Loading...</div>

  <!-- 📋 Report Results -->
  <div *ngIf="!loading && reportData.length">
    <div *ngFor="let entry of reportData" class="drug-card">
      <h3>💊 {{ entry.drug.name }} ({{ entry.drug.unit }})</h3>
      <p>Quantity in Store: <strong>{{ entry.drug.quantity }}</strong></p>

      <details>
        <summary>📦 Stock Movement History</summary>
        <ul>
          <li *ngFor="let move of entry.history">
            <strong>{{ move.type }}</strong> | {{ move.quantity }} units |
            {{ move.created_at | date: 'short' }} |
            {{ move.notes || 'No note' }}
          </li>
        </ul>
      </details>

      <details>
        <summary>👨‍⚕️ Patients Issued</summary>
        <ul>
          <li *ngFor="let p of entry.patients">
            {{ p.surname }} {{ p.other_names }} ({{ p.type }}) - {{ p.quantity }} units
            on {{ p.issued_at | date: 'mediumDate' }}
            <span *ngIf="p.ward"> | Ward: {{ p.ward }}</span>
          </li>
        </ul>
      </details>
    </div>
  </div>

  <!-- ⚠️ No Data -->
  <div *ngIf="!loading && selectedStoreId && !reportData.length">
    <p>⚠️ No drugs or data available for this store.</p>
  </div>
</div>
